<div class="status">
  <h1 class="main-title">Please wait. ShareMedix is anonymizing your files.</h1>
  <ul class="file-list" @fileList>

    <div class="file-loading-spinner" *ngIf="(uploadingFileStatus | uploadingFileStatusToNumber) > 0 " @fileItem>
      <div class="no-button-filler"></div>
      <app-status-radial-bar [progressValue]="uploadingFileStatus | uploadingFileStatusToNumber" [nameLabel]="uploadingFileStatus | uploadingFileStatusToLabel" statusLabel=""
                             [insideLabel]="uploadingFileStatus | uploadingFileStatusToNumber | number: '1.0-0'" status="uploading">
      </app-status-radial-bar>

    </div>

    <div *ngFor="let document of documents; index as i;" [ngClass]="document.progress === 100 ? 'file-loading-spinner cursor-pointer' : 'file-loading-spinner'" @fileItem>
      <div *ngIf="document.status !== 'anonymization'" class="no-button-filler"></div>
      <div [ngClass]="document.progress === 100 ? 'cursor-pointer' : 'cursor-forbidden'" >
        <app-status-radial-bar [progressValue]="document.progress" [nameLabel]="document.name" [status]="document.status"
              [statusLabel]="document.progressLabel" [insideLabel]="document.progress | roundDown | number: '1.0-0'"
                               (click)="showDocument(document)">
        </app-status-radial-bar>
      </div>
    </div>
  </ul>
<!--  <h2 class="small-title" *ngIf="uploadingStatus.progress === 100 && waitingForAnonymization">Your files are waiting to be anonymized</h2>-->
  <div class="bottom-buttons" @fileList>
    <button (click)="download()" class="button-blueGDPR" [disabled]="(uploadingFileStatus | uploadingFileStatusToNumber) > 0" @fileItem>Download all</button>
  </div>
</div>
